import AuthVisualPanel from "./AuthVisualPanel";
import styles from "./AuthSplitLayout.module.css";

/**
 * Split-screen auth chrome shared by /login and /signup.
 *
 * @param {{
 *   variant?: "user" | "admin",
 *   eyebrow: string,
 *   title: string,
 *   subtitle: string,
 *   children: import("react").ReactNode,
 *   formTestId?: string,
 * }} props
 */
export default function AuthSplitLayout({
  variant = "user",
  eyebrow,
  title,
  subtitle,
  children,
  formTestId = "auth-form-panel",
}) {
  return (
    <main
      className={styles.shell}
      data-testid="auth-split-layout"
      data-variant={variant}
    >
      <AuthVisualPanel variant={variant} />

      <section className={styles.formSide} data-testid={formTestId}>
        <div className={styles.formWrap}>
          <div className={styles.mobileBrand} data-testid="auth-mobile-brand">
            <span className={styles.brandMark} aria-hidden="true" />
            PremierLab
          </div>
          <div className={styles.eyebrow}>{eyebrow}</div>
          <h2 className={styles.title}>{title}</h2>
          <p className={styles.subtitle}>{subtitle}</p>
          {children}
        </div>
      </section>
    </main>
  );
}

export { styles as authStyles };
